<template>
    <div>
        <trial-subscription-modal v-if="!userIsInterested" @userInterested="userShowedInterestStep">
        </trial-subscription-modal>
        <trial-plans-modal v-else-if="userIsInterested && !plan" @planChosen="planStep" :user-should-see-plans="userShouldSeePlans">
        </trial-plans-modal>
        <subscription-activation-password-modals v-else-if="plan && passwordHasNotBeenSet" :plan="plan" :client-code="clientCode" :is-sears="isSears" :is-sanborns="isSanborns" @passwordSet="showSubscriptionActivatedModal">
        </subscription-activation-password-modals>
        <subscription-activated-modal v-else-if="! passwordHasNotBeenSet">
        </subscription-activated-modal>
    </div>
</template>
<script>
import SubscriptionActivatedModal from './SubscriptionActivatedModal';
import SubscriptionActivationPasswordModals from './SubscriptionActivationPasswordModals';
import TrialSubscriptionModal from './TrialSubscriptionModal';
import TrialPlansModal from './TrialPlansModal';

export default {
    components: {
        SubscriptionActivatedModal,
        SubscriptionActivationPasswordModals,
        TrialSubscriptionModal,
        TrialPlansModal
    },

    props: ['clientCode', 'chosenPlan', 'isSanborns', 'isSears', 'userHasShownInterest', 'userShouldSeePlans'],

    data() {
        return {
            userIsInterested: this.userHasShownInterest,
            plan: this.chosenPlan,
            passwordHasNotBeenSet: true,
        };
    },

    methods: {
        userShowedInterestStep() {
            this.userIsInterested = true;
        },

        showSubscriptionActivatedModal() {
            this.passwordHasNotBeenSet = false;
        },

        planStep(plan) {
            this.plan = plan;
        }
    }
};
</script>
